export const isAbsolutePath = (path) => {
  return /^([a-z]+:)/gi.test(path);
};
export const isRelativePath = (path) => {
  return !isAbsolutePath(path);
};
export const removeParameterFromUrl = (url, parameter) => {
  return url.replace(new RegExp(`[?&]${parameter}=[^&#]*(#.*)?$`), "$1").replace(new RegExp(`([?&])${parameter}=[^&]*&`), "$1");
};
export const removeParameterFromUrls = (url, ...parameters) => {
  parameters.forEach((parameter) => {
    url = removeParameterFromUrl(url, parameter);
  });
  return url;
};
